import { useEffect, useState } from "react";
import Button from "../common/Button";
import BaseModal from "../modals/BaseModal";

function buildInitialAgentId(agents, currentAgentId) {
  if (currentAgentId && agents.some((agent) => Number(agent.agent_id) === Number(currentAgentId))) {
    return String(currentAgentId);
  }

  return agents[0]?.agent_id ? String(agents[0].agent_id) : "";
}

export default function AssignCallModal({
  open,
  busy,
  agents,
  agentsLoading,
  agentsError,
  currentAgentId,
  callCount,
  onClose,
  onSubmit,
}) {
  const [selectedAgentId, setSelectedAgentId] = useState("");

  useEffect(() => {
    if (!open) {
      return;
    }

    setSelectedAgentId(buildInitialAgentId(agents, currentAgentId));
  }, [agents, currentAgentId, open]);

  return (
    <BaseModal
      open={open}
      onClose={busy ? () => {} : onClose}
      title={callCount > 1 ? "Assign Selected Calls" : "Assign Call"}
      meta={callCount > 1 ? `${callCount} calls selected` : "Assign this follow-up to a calling agent"}
      modalId="assign-call-modal"
      className="team-modal"
    >
      <form
        onSubmit={(event) => {
          event.preventDefault();

          if (!selectedAgentId) {
            return;
          }

          onSubmit({
            agent_id: Number(selectedAgentId),
          });
        }}
      >
        <div className="outbound-field">
          <span className="outbound-label">Calling Agent</span>
          <select
            className="team-modal-select"
            value={selectedAgentId}
            onChange={(event) => setSelectedAgentId(event.target.value)}
            disabled={busy || agentsLoading || !agents.length}
          >
            {agentsLoading ? (
              <option value="">Loading calling agents...</option>
            ) : agents.length ? (
              agents.map((agent) => (
                <option key={agent.agent_id} value={agent.agent_id}>
                  {agent.label || `${agent.username} - ${agent.email}`}
                </option>
              ))
            ) : (
              <option value="">
                {agentsError ? "Unable to load calling agents" : "No calling agents found"}
              </option>
            )}
          </select>
          {agentsError ? <span className="error-message">{agentsError}</span> : null}
        </div>

        <div className="modal-actions">
          <Button onClick={onClose} disabled={busy}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="gold"
            disabled={busy || agentsLoading || !selectedAgentId}
          >
            {busy ? "Assigning..." : "Assign"}
          </Button>
        </div>
      </form>
    </BaseModal>
  );
}
